import { connect } from 'react-redux';

import { COHORTS } from '../../constants/common';
import {
  getDailyCohortRange,
  getMonthlyCohortRange,
  getWeeklyCohortRange,
} from '../../reducers/analyticsApp';
import CohortSelector from '../../components/filter/CohortSelector';

const getValues = (state, field) => {
  switch (field) {
    case COHORTS.DAILY_COHORT:
      return getDailyCohortRange(state);

    case COHORTS.WEEKLY_COHORT:
      return getWeeklyCohortRange(state);

    case COHORTS.MONTHLY_COHORT:
      return getMonthlyCohortRange(state);

    default:
      return undefined;
  }
};

const mapStateToProps = (state) => ({
  getValues: (field) => getValues(state, field),
});

export default connect(mapStateToProps)(CohortSelector);
